function regenerateErrorsByField(store, errorsByField) {
  errorsByField.clear();
  for (const errorId of Object.keys(store.errors)) {
    const fieldName = store.errors[errorId].field;
    const fieldErrors = errorsByField.get(fieldName) ?? [];
    fieldErrors.push(store.errors[errorId]);
    errorsByField.set(fieldName, fieldErrors);
  }
}
export {
  regenerateErrorsByField
};
//# sourceMappingURL=regenerateErrorsByField.js.map
